import { DatadogCustomMetric } from '../types';

export const datadogCustomMetricKey = (metric: DatadogCustomMetric): string =>
    `datadog-custom-metric:${metric.name}:${metric.aggregation}`;

export const datadogCustomMetricDisplayName = (metric: DatadogCustomMetric): string =>
    `${metric.name} (${metric.aggregation})`;
